import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function accessRequiresBilling(user) {
  if (!user) return false;

  if (user.plan === 'trial') {
    return user.subscriptionStatus !== 'trialing'
      || !user.subscriptionEndDate
      || new Date(user.subscriptionEndDate) <= new Date();
  }

  if (['basic', 'growth', 'enterprise', 'pro', 'business'].includes(user.plan) && user.subscriptionStatus) {
    return !['active', 'cancelled'].includes(user.subscriptionStatus)
      || (user.subscriptionEndDate && new Date(user.subscriptionEndDate) <= new Date());
  }

  return false;
}

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  if (user.isAdmin) return children;

  const billingAllowedPaths = ['/pricing', '/payment/verify'];
  if (
    accessRequiresBilling(user)
    && !billingAllowedPaths.some((path) => location.pathname.startsWith(path))
  ) {
    return <Navigate to="/pricing?billing=required" replace />;
  }

  return children;
}
